export default __webpack_public_path__ + "c013e1d1fbdf0bfb87656e4b8a89e02d.png";